import { useMutation } from '@tanstack/react-query'

import { replaceVariant } from '../api'

const useReplaceVariantMutation = () => {
  return useMutation(replaceVariant)
}

export default useReplaceVariantMutation
